import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center q-py-lg" }
const _hoisted_2 = {
  key: 0,
  class: "bg-orange-2 text-center text-h6 q-my-lg q-pa-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_import_posts_btn = _resolveComponent("import-posts-btn")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_import_request = _resolveComponent("import-request")!
  const _component_request_new_posts = _resolveComponent("request-new-posts")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_import_posts_btn, {
        account: _ctx.account,
        color: "primary",
        rounded: ""
      }, null, 8, ["account"])
    ]),
    _createVNode(_component_q_separator),
    (_ctx.supportRequested)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Client Requested Support "))
      : _createCommentVNode("", true),
    (_ctx.account.reconnectRequest)
      ? (_openBlock(), _createBlock(_component_import_request, {
          key: 1,
          request: _ctx.account.reconnectRequest,
          platform: _ctx.account.socialSite.name
        }, null, 8, ["request", "platform"]))
      : (_openBlock(), _createBlock(_component_request_new_posts, {
          key: 2,
          account: _ctx.account
        }, null, 8, ["account"])),
    _createVNode(_component_q_separator)
  ]))
}